import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError, } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { RegraDto, UpdateRegraDto } from '@/api.types';

export async function GetRegras(skip: number, take: number) {
  return api
    .get(Endpoints.REGRA, { params: { skip: skip, take: take } })
    .then((response) => {
      return GetApiReturn<RegraDto>(response.data as Array<RegraDto>);
    })
    .catch((error) => {
      ValidateAxiosError<RegraDto>(error, 'Falha ao listar regras.');
      return GetApiReturnError<RegraDto>();
    });
}

export async function SetRegra(id: number, ativa: boolean) {
  const dto: UpdateRegraDto = { ativa };
  return api
    .put(Endpoints.REGRA + '/' + id, dto)
    .then(() => {
      return 'Regra atualizada.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao atualizar a regra.');
    });
}
